import { Controller } from "stimulus"
import flatpickr from "flatpickr";
import rangePlugin from "flatpickr/dist/plugins/rangePlugin";
import "flatpickr/dist/themes/light.css";

// Connects to data-controller="date-range-filter"
export default class extends Controller {
  static targets = [ "input" ]
  connect() {
    flatpickr(this.inputTarget, {
      plugins: [new rangePlugin({ input: this.inputTargets[1] })],
      mode: "range",
      dateFormat: 'd M Y',
      maxDate: 'today',
    });
  }
}
